export enum EventType {
  Cancel = "Cancel" as any,
  Add = "Add" as any,
  Update = "Update" as any,
  Delete = "Delete" as any,
}
